import { RouteParameters } from "./route-parameters";

const ORGANIZATION_ADMIN_ROUTING = {
  CHECKOUT: {
    [RouteParameters.CHECKOUT_ID]: {
      ROOT: `/dashboard/organization/:${RouteParameters.ORGANIZATION_ID}/admin/checkout/:${RouteParameters.CHECKOUT_ID}`,
    },
  },
  ORGANIZATION_MANAGEMENT: {
    ROOT: `/dashboard/organization/:${RouteParameters.ORGANIZATION_ID}/admin/organization-management`,
  },
} as const;

export { ORGANIZATION_ADMIN_ROUTING };
